import { ActionButton } from 'src/sections/employer-data/shared/components/action-button';

// ----------------------------------------------------------------------

type MoveCoverageButtonProps = {
  onClick: () => void;
};

export function MoveCoverageButton({ onClick }: MoveCoverageButtonProps) {
  return <ActionButton label="Move coverage" testId="move-coverage-button" onClick={onClick} />;
}
